import React from 'react';
import { useAuth } from '../hooks/useAuth';
import { useStripePayment } from '../hooks/useStripePayment';

const plans = [
  { id: 'basic', name: 'Básico', price: 9.99, features: ['Listado básico', '5 proyectos/mes', 'Soporte por email'] },
  { id: 'pro', name: 'Profesional', price: 19.99, features: ['Listado destacado', 'Proyectos ilimitados', 'Soporte prioritario'] },
  { id: 'premium', name: 'Premium', price: 29.99, features: ['Listado premium', 'Proyectos ilimitados', 'Soporte 24/7', 'Herramientas avanzadas'] },
];

const PricingPlans = () => {
  const { user } = useAuth();
  const { subscribeToPlan } = useStripePayment();

  const handleSubscribe = async (planId) => {
    try {
      await subscribeToPlan(planId);
      // Manejar éxito (por ejemplo, mostrar una notificación)
    } catch (error) {
      console.error('Error al suscribirse:', error);
      // Manejar error (por ejemplo, mostrar un mensaje de error)
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
      {plans.map((plan) => (
        <div key={plan.id} className="border rounded-lg p-8 text-center bg-white shadow-lg hover:shadow-xl transition-shadow duration-300 transform hover:scale-105">
          <h3 className="text-2xl font-semibold mb-2 text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-blue-600">{plan.name}</h3>
          <p className="text-4xl font-bold text-gray-800 mb-4">${plan.price}/mes</p>
          <ul className="mb-6 space-y-3 text-gray-600">
            {plan.features.map((feature, index) => (
              <li key={index} className="flex items-center justify-center">
                <span className="text-teal-500 mr-2">✓</span>{feature}
              </li>
            ))}
          </ul>
          <button
            onClick={() => handleSubscribe(plan.id)}
            className="bg-blue-600 text-white px-6 py-3 rounded-md hover:bg-blue-700 transition-colors duration-300"
          >
            Suscribirse
          </button>
        </div>
      ))}
    </div>
  );
};

export default PricingPlans;
